<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240); margin-bottom: 15px"
      :title="this.project"
      :sub-title="this.warehouse"
      @back="() => this.$router.back()">
    </a-page-header>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="1" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="archived" slot-scope="text, item">
        <a-popconfirm
          title="确定存档吗?"
          :disabled="text"
          @confirm="() => archived(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
        </a-popconfirm>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleAttachment(record)">附件</a>
          <a-divider v-if="!record.is_archived" type="vertical" />
          <a v-if="!record.is_archived" @click="handleEdit(record)">编辑</a>
          <a-divider v-if="!record.is_archived" type="vertical" />
          <a-popconfirm
            v-if="!record.is_archived"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import {
  inventory_adjustment_list,
  inventory_adjustment_create,
  inventory_adjustment_delete,
  inventory_adjustment_archived
} from '@/api/trade_inventory_adjustment'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      mdl: {},
      project: '',
      warehouse: '',
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '仓库',
          ellipsis: true,
          align: 'center',
          width: 150,
          dataIndex: 'warehouse'
        },
        {
          title: '提货单毛量',
          ellipsis: true,
          align: 'center',
          width: 150,
          dataIndex: 'gross_weight',
          customRender: (text, record) => this.$Dictionaries.unit[record.unit] ? text + this.$Dictionaries.unit[record.unit] : text
        },
        {
          title: '提货单净量',
          ellipsis: true,
          align: 'center',
          width: 150,
          dataIndex: 'net_weight',
          customRender: (text, record) => this.$Dictionaries.unit[record.unit] ? text + this.$Dictionaries.unit[record.unit] : text
        },
        {
          title: '过磅量',
          ellipsis: true,
          align: 'center',
          width: 150,
          dataIndex: 'weighing_capacity',
          customRender: (text, record) => this.$Dictionaries.unit[record.unit] ? text + this.$Dictionaries.unit[record.unit] : text
        },
        {
          title: '预估人民币价格',
          width: 150,
          align: 'center',
          dataIndex: 'unit_price_cny'
        },
        {
          title: '出入库时间',
          width: 150,
          align: 'center',
          dataIndex: 'in_out_date',
          customRender: (text) => text === '1970-01-01' ? '' : text
        },
        {
          title: '审批状态',
          dataIndex: 'is_approval_needed',
          align: 'center',
          width: 100,
          customRender: (text) => text ? this.$Dictionaries.approval_result[text] : '未开启审批'
        },
        {
          title: '已存档',
          dataIndex: 'is_archived',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'archived' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return inventory_adjustment_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    this.queryParam = {
      inventory_id: this.$route.params.inventory_id
    }
    this.project = this.$route.query.project
    this.warehouse = '仓库：' + this.$route.query.warehouse
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      this.mdl = { code: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDay() }
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAttachment (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/inventory/' + this.$route.params.inventory_id + '/adjustment/' + record.id + '/attachment', query: { warehouse: record.warehouse, count: record.count } })
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/inventory/' + this.$route.params.inventory_id + '/adjustment/' + record.id, query: { warehouse_id: record.warehouse_id } })
    },
    archived (record) {
      inventory_adjustment_archived({ id: record.id, is_archived: !record.is_archived }).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleDelete (record) {
      inventory_adjustment_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          values = { ...values, ...data }
            // 新增
          if (values['gross_weight'] === null) {
            values['gross_weight'] = 0
          }
          if (values['net_weight'] === null) {
            values['net_weight'] = 0
          }
          if (values['weighing_capacity'] === null) {
            values['weighing_capacity'] = 0
          }
          if (values['unit_price_cny'] === null) {
            values['unit_price_cny'] = 0
          }
          values.inventory_id = this.$route.params.inventory_id
          this.confirmLoading = true
          inventory_adjustment_create(values).then(res => {
              // 刷新表格
            if (res.code === 1000) {
                this.visible = false
                // 重置表单数据
                form.resetFields()
                this.$refs.table.refresh()
              }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    }
  }
}
</script>
